import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { switchMap } from 'rxjs';
import { APP_CONFIG } from '../../core';
import { CaseService, ModelService } from '../../services';
import { BaseComponent } from '../base';


/**
* Modal component to confirm before exit from ray site.
*/
@Component({
	selector: 'app-closure-modal',
	templateUrl: './closure-modal.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ClosureModalComponent extends BaseComponent implements OnInit {

	private readonly modelSrv = inject(ModelService);
	private readonly caseSrv = inject(CaseService);
	public activeModal = inject(NgbActiveModal);
	private readonly config = inject(APP_CONFIG);

	isReadOnly = false;


	ngOnInit(): void {
		this.caseSrv.isReadOnly().subscribe(res => this.isReadOnly = res);
	}

	get isSaveDisabled(): boolean {
		return this.isReadOnly || this.isMechAxisWorkflow;
	}

	/**
	* Close site without save current state.
	*/
	closeWithoutSave(): void {
		globalThis.location.href = this.config.patplanSite;
	}

	/**
	* Close site and save current state.
	*/
	closeWithSave(): void {
		this.caseSrv.getCurrentCase().pipe(
			switchMap(_case => this.modelSrv.persistModel(_case.id, _case.userGuid))
		).subscribe(() => globalThis.location.href = this.config.patplanSite);
	}

}
